module.exports = __webpack_public_path__ + "static/img/LavaPro-Reg.39ae8e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/LavaPro-Reg.svg
// module id = lYoC
// module chunks = 0